import { IExampleDrivers, IExampleLocation } from './interfaces';

const drivers: IExampleDrivers = {
  name: `Barcelona`,
  location: {
    lat: 41.390205,
    lng: 2.154007,
  },
  drivers: {
    label: [`Pau `, `Daniel`, `Xavier`],
    start_address: [
      `Ronda del General Mitre, 90, 08021, Barcelona, España`,
      `Ronda del General Mitre, 90, 08021, Barcelona, España`,
      `Ronda del General Mitre, 90, 08021, Barcelona, España`,
    ],
    start_address_coordinates: [
      {
        lat: 41.3998287,
        lng: 2.1350718,
      },
      {
        lat: 41.3998287,
        lng: 2.1350718,
      },
      {
        lat: 41.3998287,
        lng: 2.1350718,
      },
    ],
    end_address: [
      `Ronda del General Mitre, 90, 08021, Barcelona, España`,
      `Carrer de Ganduxer, 122, 08022, Barcelona, España`,
      `Ronda del General Mitre, 90, 08021, Barcelona, España`,
    ],
    end_address_coordinates: [
      {
        lat: 41.3998287,
        lng: 2.1350718,
      },
      {
        lat: 41.4028316,
        lng: 2.1318668,
      },
      {
        lat: 41.3998287,
        lng: 2.1350718,
      },
    ],
  },
};

const stops: IExampleLocation = {
  name: `Barcelona`,
  location: {
    lat: 41.390205,
    lng: 2.154007,
  },
  stops: {
    label: [
      `Sant Antoni Gloriós`,
      `L’Home dels Nassos`,
      `Pastelería Hoffmann`,
      `Mediamanga`,
      `Cafés el magnífico`,
      `Bar Celta Pulpería`,
      `Les Dues Sicilies`,
      `Denassus`,
      `La Porca`,
      `Taberna Textxu`,
    ],
    address: [
      `Carrer de Manso, 42, 08015 Barcelona, Spain`,
      `Carrer de Melcior de Palau, 62, 08028 Barcelona, Spain`,
      `41.3850, 2.1827`,
      `Carrer d'Aribau, 13, 08011 Barcelona`,
      `Carrer de l'Argenteria, 64, 08003 Barcelona, Spain`,
      `Carrer de la Princesa, 50, 08003 Barcelona, Spain`,
      `C/ dels Carders, 22, 08003 Barcelona, Spain`,
      `Carrer de Blai, 53, 08004 Barcelona, Spain`,
      `Carrer de Mata, 16, 08004 Barcelona, Spain`,
      `Carrer del Tajo, 29, 08032 Barcelona`,
    ],
    address_coordinates: [
      {
        lat: 41.3766931,
        lng: 2.16093,
      },
      {
        lat: 41.379392,
        lng: 2.1338083,
      },
      {
        lat: 41.3849898,
        lng: 2.1826778,
      },
      {
        lat: 41.3862343,
        lng: 2.1620049,
      },
      {
        lat: 41.3834575,
        lng: 2.1809678,
      },
      {
        lat: 41.386761,
        lng: 2.1824014,
      },
      {
        lat: 41.3866036,
        lng: 2.1802758,
      },
      {
        lat: 41.3743263,
        lng: 2.1626881,
      },
      {
        lat: 41.3729884,
        lng: 2.1706795,
      },
      {
        lat: 41.4297978,
        lng: 2.1624553,
      },
    ],
    address_details: [`Entrada por lateral`, ``, ``, ``, ``, ``, `Local`, `Local`, `4º 1ª, Esc. derecha`, `Bajos 2ª`],
    delivery_label: [
      `Marc García`,
      `Júlia Martínez`,
      `Leo Sanchez`,
      `Martina Torres`,
      `Àlex Gil`,
      `Jan Ruiz`,
      `Nil Serra`,
      `Emma Soler`,
      `Pol Roca`,
      `Lucía Molina`,
    ],
    delivery_address: [
      `Carrer del Mestre Nicolau 24, 08021, Barcelona`,
      `Carrer de Pau Claris, 79`,
      `Carrer dels Almogàvers, 119`,
      `Carrer del Doctor Martí Julià, 60`,
      `Carrer de Papin, 3, Barcelona`,
      `Av. de Josep Tarradellas, 64`,
      `Carrer de Blasco de Garay, 14`,
      `Gran Via de les Corts Catalanes, 564`,
      `Carrer de Muntaner, 103-85`,
      `Carrer de Sardenya, 85`,
    ],
    delivery_address_coordinates: [
      {
        lat: 41.3944195,
        lng: 2.1435744,
      },
      {
        lat: 41.3891945,
        lng: 2.1713129,
      },
      {
        lat: 41.3973947,
        lng: 2.1896855,
      },
      {
        lat: 41.3735164,
        lng: 2.1222792,
      },
      {
        lat: 41.3770386,
        lng: 2.1334107,
      },
      {
        lat: 41.3855093,
        lng: 2.1430536,
      },
      {
        lat: 40.4311562,
        lng: -3.7114636,
      },
      {
        lat: 41.3838035,
        lng: 2.1615057,
      },
      {
        lat: 41.3887897,
        lng: 2.15636,
      },
      {
        lat: 41.3936943,
        lng: 2.1860042,
      },
    ],
    delivery_address_details: [`2n 3ª`, `4t 1ª, esc. derecha`, `3º 2ª`, ``, ``, ``, ``, ``, ``, ``],
  },
};

export { drivers, stops };
